import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'
import QualificationCheckPage from 'app/BCKSPage/QualificationCheckPage'
import { isToggleEnabled } from 'configs/toggle-feature'

interface PropsQualificationCheckPage {
  isKSSelectionEnabled: boolean
}

export const getServerSideProps = async () => {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')

  return {
    props: {
      isKSSelectionEnabled,
    },
  }
}

const QualificationCheckPageIndex = (props: PropsQualificationCheckPage) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return <QualificationCheckPage />
}

// eslint-disable-next-line react/display-name
QualificationCheckPageIndex.Layout = ({ children }) => children

export default QualificationCheckPageIndex
